<div class="main-container">
  <div class="app-nav">
    <ul>
      <li><a style="background-color: #c25423" (click)="showTracker()">Statement Tracker</a></li>
      <li class="separator"><span class="Appkit4-icon icon-vertical-more-outline"></span></li>
      @if (createNewTabIsOpen) {
<li class="tabs" [ngClass]="{'disabled': tableDataLoading}">
        <a [ngClass]="{'active': activeTab?.id === idCreateNew}"
           (click)="addTabOrNavigate(idCreateNew)">
          Create New
          <span class="Appkit4-icon icon-close-outline" (click)="closeTab(idCreateNew)"></span>
        </a>
      </li>
}
      @for (tab of tabs; track $index) {
<li class="tabs" [ngClass]="{'disabled': tableDataLoading}">
        <a [ngClass]="{'active': tab.id === activeTab?.id}"
           (click)="addTabOrNavigate(tab.id)">
          {{ tab.id }}
          <span class="Appkit4-icon icon-close-outline" (click)="closeTab(tab.id)"></span>
        </a>
      </li>
}
    </ul>
  </div>
  <div class="grid-container" id="p-grid-container" [ngStyle]="{'display': !activeTab ? 'block' : 'none'}">
    <div class="top-toolbar dst-toolbar">
      <div class="float-left">
        <span class="Appkit4-icon icon-refresh-outline"></span>
        <ap-dropdown [list]="taxYears" [selectType]="'single'" [title]="'Tax Year'" [inputAriaLabel]="'Tax Year'"
                     [hideTitleOnInput]="true"
                     [(ngModel)]="selectedTaxYearItem" (onSelect)="onTaxYearChanged($event)" style="margin-right: 5px;">
          @for (item of taxYears; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                 [ariaLabel]="setTaxYearAriaLabel(item)"
                                 (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
}
        </ap-dropdown>
        <gtw-df-me-dropdown class="top-filter-select" [customActionCode]="32136" (selectedMes)="selectedMeChanged($event)"></gtw-df-me-dropdown>
        <ap-button [compact]="true" [btnType]="'primary'" [label]="'Filter'" class="ap-mr-spacing-3" (onClick)="refresh(true)"></ap-button>
      </div>
      <div class="float-right">
        @if (!(dstSharedService.isSystemLock && (dstSharedService.user.roleLevel <= 3))) {
<ap-button [compact]="true" [btnType]="'primary'" class="ap-mr-spacing-3" [ariaLabel]="'Create New'" [disabled]="dstSharedService.user.roleLevel < 2" (onClick)="createDisclosureNew()"
         >
          <span class="Appkit4-icon a-btn-icon icon-plus-fill"></span>Create New
        </ap-button>
}
        <a href="#/custom-report" style="text-decoration: none; display: flex">
          <ap-button [compact]="true" [btnType]="'primary'" class="ap-mr-spacing-3" [ariaLabel]="'View All'">
            <span class="Appkit4-icon a-btn-icon icon-platform-outline"></span>View All
          </ap-button>
        </a>
        <ap-search
          [searchType]="'secondary'"
          [ariaLabel]="'Statement tracker search'"
          [placeholder]="'Search'"
          [disabled]="tableDataLoading"
          [filtered]="false"
          [isRecentSearch]="false"
          [(ngModel)]="globalSearchTerm"
          (onSearch)="searchg($event)"
          (onKeydown)="searchg($event)"
          (onClear)="clearGlobalSearch()">
        </ap-search>
      </div>
    </div>
    <div class="grid-toolbar dst-grid-toolbar">
      <div class="float-left">
        <span class="Appkit4-icon icon-view-outline"></span>
        <span class="Appkit4-icon icon-down-chevron-outline"></span>
        <span class="toolbar-btn" (click)="exportToExcel()">
          <span class="Appkit4-icon icon-save-outline"></span>
          &nbsp;Export to Excel
          @if (exportingExcel) {
<span class="ml-1"> <i class="fa fa-spinner fa-spin"></i> </span>
}
        </span>
        <span class="Appkit4-icon icon-open-in-new-window-outline"></span>
        <span class="toolbar-btn" (click)="resetColumnFilters()">
          <span class="Appkit4-icon icon-refresh-outline"></span>
          &nbsp;Clear Grid Filters
        </span>
      </div>
      <div class="float-right" style="display: flex;">
      @if (tableActionStatus.inProgress) {
<span>
        <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
      </span>
}
        <span>Total records: {{totalRecords}}</span>
      </div>
    </div>
    <div class="dst-mat-grid-layout">
      @if (tableDataLoading) {
        <div class="dst-mat-grid-loading">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      }
      <div #matGridContainer class="dst-mat-grid" (scroll)="onScroll()">
        <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort #scrollSort="matSort"
               (matSortChange)="onMatSortChange()" class="dst-mat-table">
          <ng-container matColumnDef="statementId" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="stmt-frozen-col stmt-id-col"
                [ngStyle]="getColStyle(frozenCols[0])"
                [dstMatColumnResize]="getColWidthPx(frozenCols[0])"
                (widthChange)="onColumnWidthChange(frozenCols[0], $event)">
              {{ frozenCols[0].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" class="stmt-frozen-col stmt-id-col" [ngStyle]="getColStyle(frozenCols[0])">
              <dst-stmt-id-btn [mode]="'statementTracker'" [gridData]="tableData" [rowData]="rowData" [markAsOptions]="markAsOptions"
                               (actionClick)="onActionClicked($event)">
              </dst-stmt-id-btn>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="leId" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="stmt-frozen-col legal-entity-col"
                [ngStyle]="getColStyle(frozenCols[1])"
                [dstMatColumnResize]="getColWidthPx(frozenCols[1])"
                (widthChange)="onColumnWidthChange(frozenCols[1], $event)">
              {{ frozenCols[1].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" class="stmt-frozen-col legal-entity-col"
                [ngStyle]="getColStyle(frozenCols[1])">
              <span class="text-color-primary">{{ rowData.leId }}</span><br>
              <span>{{ rowData.entityName }}</span><br>
              <span>{{ rowData.fiscalEnd ? 'Year End: ' + rowData.fiscalEnd : '' }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="statementId_filter" sticky>
            <th mat-header-cell *matHeaderCellDef class="stmt-frozen-col stmt-id-col" [ngStyle]="getColStyle(frozenCols[0])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="frozenCols[0].filterUserInput"
                     (input)="filterCol($event, 'statementId', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="leId_filter" sticky>
            <th mat-header-cell *matHeaderCellDef class="stmt-frozen-col legal-entity-col"
                [ngStyle]="getColStyle(frozenCols[1])">
              <ap-dropdown class="dst-mat-col-filter" [selectType]="'multiple'" [enableNgContent]="false"
                [list]="getDropdownOptionsByID('leid')" [optionName]="'val'" [optionValue]="'val'"
                [listId]="'dst-grid-filter-st-leid'"
                [title]="'All'" [inputAriaLabel]="'Legal entity filter'" [hideTitleOnInput]="true"
                [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                (onFilterResult)="onDropdownFilterResult('leid', $event)"
                [(ngModel)]="frozenCols[1].filterUserInput"
                (onSelect)="filterLeidCol($event.selected, 'leId', ' ')">
              </ap-dropdown>
            </th>
          </ng-container>
 
        <ng-container matColumnDef="TAXYEAR">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[0])"
              [dstMatColumnResize]="getColWidthPx(cols[0])" (widthChange)="onColumnWidthChange(cols[0], $event)">
            {{ cols[0].header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[0])" style="text-align: center;">
            <span>{{ rowData.TAXYEAR }}</span>
          </td>
        </ng-container>
 
        <ng-container matColumnDef="businessName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[1])"
              [dstMatColumnResize]="getColWidthPx(cols[1])" (widthChange)="onColumnWidthChange(cols[1], $event)">
            {{ cols[1].header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[1])" style="white-space: initial;">
            <span>{{ rowData.businessName }}</span>
          </td>
        </ng-container>
 
        <ng-container matColumnDef="disclosureShortName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[2])"
              [dstMatColumnResize]="getColWidthPx(cols[2])" (widthChange)="onColumnWidthChange(cols[2], $event)">
            {{ cols[2].header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[2])">
            <span class="text-color-primary">{{ rowData.disclosureShortName }}</span>
          </td>
        </ng-container>
 
        <ng-container matColumnDef="creationSource">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[3])"
              [dstMatColumnResize]="getColWidthPx(cols[3])" (widthChange)="onColumnWidthChange(cols[3], $event)">
            {{ cols[3].header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[3])">
            <div class="text-color-primary three-line-ellipse">{{ rowData.creationSource }}</div>
          </td>
        </ng-container>
 
        <ng-container matColumnDef="attachment_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[4])"
              [dstMatColumnResize]="getColWidthPx(cols[4])" (widthChange)="onColumnWidthChange(cols[4], $event)">
            {{ cols[4].header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[4])" style="white-space: initial;">
            <span>{{ rowData.attachment_name }}</span>
          </td>
        </ng-container>
 
        <ng-container matColumnDef="gtw_source_desc">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[5])"
              [dstMatColumnResize]="getColWidthPx(cols[5])" (widthChange)="onColumnWidthChange(cols[5], $event)">
            {{ cols[5].header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[5])">
            <a [href]="rowData.gtw_source_link" style="color: red;">{{ rowData.gtw_source_desc }}</a>
          </td>
        </ng-container>
 
        <ng-container matColumnDef="associatedStatements">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[6])"
              [dstMatColumnResize]="getColWidthPx(cols[6])" (widthChange)="onColumnWidthChange(cols[6], $event)">
            {{ cols[6].header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[6])">
            @if (rowData.associatedStatements) {
              <div style="text-overflow: ellipsis;overflow:hidden;width:100%"
                   [title]="rowData.associatedStatements ? rowData.associatedStatements.split(',')[0] : ''">
                <a href="javascript:void(0);" (click)="openChildDisclosure(rowData.associatedStatements.split(',')[0], rowData)">
                  {{ rowData.associatedStatements.split(',')[0] }}
                </a>
              </div>
            }
            @if (rowData.associatedStatements && rowData.associatedStatements.split(',').length > 1) {
              <div style="text-overflow: ellipsis;overflow:hidden;width:100%"
                   [title]="rowData.associatedStatements && rowData.associatedStatements.split(',').length > 1 ? rowData.associatedStatements.split(',')[1] : ''">
                <a href="javascript:void(0);" (click)="openChildDisclosure(rowData.associatedStatements.split(',')[1], rowData)">
                  {{ rowData.associatedStatements.split(',')[1] }}
                </a>
              </div>
            }
          </td>
        </ng-container>
 
        <ng-container matColumnDef="projectName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[7])"
              [dstMatColumnResize]="getColWidthPx(cols[7])" (widthChange)="onColumnWidthChange(cols[7], $event)">
            {{ cols[7].header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[7])">
            @if (rowData.projectName) {
              <span>{{ rowData.projectName }} - {{ rowData.projectStepName }}<br>{{ rowData.PROJECTBSLACODE }}</span>
            }
          </td>
        </ng-container>
 
        <ng-container matColumnDef="dcnName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[8])"
              [dstMatColumnResize]="getColWidthPx(cols[8])" (widthChange)="onColumnWidthChange(cols[8], $event)">
            {{ cols[8].header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[8])">
            <span class="text-color-primary">{{ rowData.dcnName }}</span>
          </td>
        </ng-container>
 
        <ng-container matColumnDef="createdBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[9])"
              [dstMatColumnResize]="getColWidthPx(cols[9])" (widthChange)="onColumnWidthChange(cols[9], $event)">
            {{ cols[9].header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[9])">
            @if (rowData.createdBy) {
              <span>
                <span class="text-color-primary">Created By: </span>
                {{ rowData.createdBy }}&nbsp;
                {{ rowData.createdOnFormatted ? '(' + rowData.createdOnFormatted + ')' : '' }}<br>
              </span>
            }
            @if (rowData.modifiedBy) {
              <span>
                <span class="text-color-primary">Modified By: </span>
                {{ rowData.modifiedBy }}&nbsp;
                {{ rowData.modifiedFormatted ? '(' + rowData.modifiedFormatted + ')' : '' }}
              </span>
            }
          </td>
        </ng-container>
 
        <ng-container matColumnDef="pdfPreview">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[10])"
              [dstMatColumnResize]="getColWidthPx(cols[10])" (widthChange)="onColumnWidthChange(cols[10], $event)">
            {{ cols[10].header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[10])" style="text-align: center;">
            @if (rowData.statementId && rowData.statementId !== '0' && rowData.statementId !== 0) {
              <i class="pi pi-file-pdf" style="cursor: pointer; color: #D04A02;"
                 (click)="showPDFView('pdf-viewer', rowData.statementId)"></i>
            }
          </td>
        </ng-container>
 
        <ng-container matColumnDef="TAXYEAR_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[0])">
            <ap-dropdown class="dst-mat-col-filter" [selectType]="'multiple'" [enableNgContent]="false"
              [list]="getDropdownOptionsByID('tax_year')" [optionName]="'val'" [optionValue]="'val'"
              [listId]="'dst-grid-filter-st-tax-year'"
              [title]="'All'" [inputAriaLabel]="'Tax year filter'" [hideTitleOnInput]="true"
              [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
              (onFilterResult)="onDropdownFilterResult('tax_year', $event)"
              [(ngModel)]="cols[0].filterUserInput"
              (onSelect)="filterMultiSelectCol($event.selected, 'TAXYEAR')">
            </ap-dropdown>
          </th>
        </ng-container>
 
        <ng-container matColumnDef="businessName_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[1])">
            <input type="text" class="dst-mat-col-filter" [(ngModel)]="cols[1].filterUserInput"
                   (input)="filterCol($event, 'businessName', 'contains')">
          </th>
        </ng-container>
 
        <ng-container matColumnDef="disclosureShortName_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[2])" style="overflow: visible;">
            <ap-dropdown class="dst-mat-col-filter" [selectType]="'multiple'" [enableNgContent]="false"
              [list]="getDropdownOptionsByID('disclosure')" [optionName]="'val'" [optionValue]="'val'"
              [listId]="'dst-grid-filter-st-disclosure'"
              [title]="'All'" [inputAriaLabel]="'Disclosure filter'" [hideTitleOnInput]="true"
              [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
              (onFilterResult)="onDropdownFilterResult('disclosure', $event)"
              [(ngModel)]="cols[2].filterUserInput"
              (onSelect)="filterMultiSelectCol($event.selected, 'disclosureShortName')">
            </ap-dropdown>
          </th>
        </ng-container>
 
        <ng-container matColumnDef="creationSource_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[3])">
            <ap-dropdown class="dst-mat-col-filter" [selectType]="'multiple'" [enableNgContent]="false"
              [list]="getDropdownOptionsByID('creationSrc')" [optionName]="'val'" [optionValue]="'val'"
              [listId]="'dst-grid-filter-st-creation-src'"
              [title]="'All'" [inputAriaLabel]="'Creation source filter'" [hideTitleOnInput]="true"
              [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
              (onFilterResult)="onDropdownFilterResult('creationSrc', $event)"
              [(ngModel)]="cols[3].filterUserInput"
              (onSelect)="filterMultiSelectCol($event.selected, 'creationSource')">
            </ap-dropdown>
          </th>
        </ng-container>
 
        <ng-container matColumnDef="attachment_name_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[4])">
            <ap-button class="stmt-filter-placeholder" [compact]="true" [btnType]="'primary'" [type]="'button'" [label]="'All'"></ap-button>
          </th>
        </ng-container>
 
        <ng-container matColumnDef="gtw_source_desc_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[5])">
            <ap-button class="stmt-filter-placeholder" [compact]="true" [btnType]="'primary'" [type]="'button'" [label]="'All'"></ap-button>
          </th>
        </ng-container>
 
        <ng-container matColumnDef="associatedStatements_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[6])">
            <ap-button class="stmt-filter-placeholder" [compact]="true" [btnType]="'primary'" [type]="'button'" [label]="'All'"></ap-button>
          </th>
        </ng-container>
 
        <ng-container matColumnDef="projectName_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[7])">
            <ap-dropdown class="dst-mat-col-filter" [selectType]="'multiple'" [enableNgContent]="false"
              [list]="getDropdownOptionsByID('project')" [optionName]="'val'" [optionValue]="'val'"
              [listId]="'dst-grid-filter-st-project'"
              [title]="'All'" [inputAriaLabel]="'Project filter'" [hideTitleOnInput]="true"
              [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
              (onFilterResult)="onDropdownFilterResult('project', $event)"
              [(ngModel)]="cols[7].filterUserInput"
              (onSelect)="filterMultiSelectCol($event.selected, 'projectName')">
            </ap-dropdown>
          </th>
        </ng-container>
 
        <ng-container matColumnDef="dcnName_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[8])">
            <input type="text" class="dst-mat-col-filter" [(ngModel)]="cols[8].filterUserInput"
                   (input)="filterCol($event, 'dcnName', 'startsWith')">
          </th>
        </ng-container>
 
        <ng-container matColumnDef="createdBy_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[9])">
            <input type="text" class="dst-mat-col-filter" [(ngModel)]="cols[9].filterUserInput"
                   (input)="filterCol($event, 'createdBy', 'contains')">
          </th>
        </ng-container>
 
        <ng-container matColumnDef="pdfPreview_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[10])"></th>
        </ng-container>
 
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 45px;"></tr>
        <tr mat-header-row *matHeaderRowDef="filterColumns; sticky: true" class="dst-mat-filter-row" style="height: 45px;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 70px;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell dst-mat-no-records" [attr.colspan]="displayedColumns.length">
            <span>No Records Found.</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
  </div>
  <!-- tab containers as no-cache workaround -->
  @if (createNewTabIsOpen) {
<div class="create-container" [ngStyle]="{'display': activeTab?.id === idCreateNew ? 'block' : 'none'}">
    <dst-create-disclosure></dst-create-disclosure>
  </div>
}
  @for (tab of tabs; track $index) {
<div class="create-container" [ngStyle]="{'display': activeTab?.id === tab.id ? 'block' : 'none'}">
    @if (userClickedRow) {
<dst-create-disclosure-shared [rowObj]="userClickedRow"></dst-create-disclosure-shared>
}
  </div>
}
  <!-- end of tab containers -->
</div>
 
<!-- stmt id button sub component addition for dropdown hidding issue fix caused by stmt id freezed column-->
  @if (ddRow && ddRow.showDropdown) {
<dst-dropdown-menu [rowObject]="ddRow" [mode]="'statementTracker'" [menuPos]="menuPos"
    (taggingProject)="onProjectTagging()" (copyReplicate)="onCopyOrReplicate($event)"
    (showUnmatchConfirm)="onShowUnmatchConfirm()" (showDeleteConfirm)="onShowDeleteConfirm()"
    (matchTracker)="onMatchStatementTracker()" (saveSuccess)="onSaveSuccess()">
  </dst-dropdown-menu>
}
  @if (ddRow && ddRow.showExtendedMenu) {
<dst-mark-as-template (showMarkOtherReason)="onShowMarkOtherReason()" [rowObject]="ddRow"
    [markAsOptions]="markAsOptions" [menuPos]="menuPos"></dst-mark-as-template>
}
 
@if (showConfirmDeleteModal) {
<ap-modal #dstDeleteConfirmDialog
         
          [appModalId]="'confirm-delete'"
          [ariaLabel]="'Delete statement confirmation'"
          [closable]="true"
          [style]="{'width': '31.25rem'}"
          (onClose)="closeDSTDeleteConfirmDialog('confirm-delete')">
  <ng-template ngTemplate="header">
    <div class="flex-fill d-flex align-items-center">
      <ap-badge value="Warning" type="warning"></ap-badge>
      <span class="a-color-dark a-font-12">Statement Tracker Action</span>
    </div>
  </ng-template>
  <div class="st-modal-body">
    <div class="a-h3">Delete Statement</div>
    <div class="a-p4 ap-mt-spacing-3 text-description">Are you sure you want to delete the statement record?</div>
  </div>
  <ng-template ngTemplate="footer">
    <ap-button [compact]="true" [btnType]="'secondary'" [label]="'NO'" class="ap-mr-spacing-3" (onClick)="closeDSTDeleteConfirmDialog('confirm-delete')"></ap-button>
    <ap-button [compact]="true" [btnType]="'primary'" [label]="'YES'" (onClick)="closeDSTDeleteConfirmDialogOk('confirm-delete')"></ap-button>
  </ng-template>
</ap-modal>
}
 
@if (showMarkOtherReasonModal) {
<ap-modal #dstMarkOtherReasonDialog
         
          [appModalId]="'mark-other-reason'"
          [ariaLabel]="'Mark as N/A reason'"
          [closable]="true"
          [style]="{'width': '31.25rem'}"
          (onClose)="closeDSTMarkOtherReasonDialog('mark-other-reason')">
  <ng-template ngTemplate="header">
    <div class="flex-fill d-flex align-items-center">
      <span class="a-color-dark a-font-12">Statement Tracker Action</span>
    </div>
  </ng-template>
  <div class="st-modal-body">
    <div class="a-h3">Mark As N/A</div>
    <div class="a-form-label">Please provide details for N/A</div>
    <input aria-label="N/A details" class="a-text-input w-100" [(ngModel)]="markAsReason">
  </div>
  <ng-template ngTemplate="footer">
    <ap-button [compact]="true" [btnType]="'secondary'" class="ap-mr-spacing-3" [label]="'CANCEL'" class="ap-mr-spacing-3" (onClick)="closeDSTMarkOtherReasonDialog('mark-other-reason')"></ap-button>
    <ap-button [compact]="true" [btnType]="'primary'" [label]="'SAVE'" (onClick)="closeDSTMarkOtherReasonDialogOk('mark-other-reason')"></ap-button>
  </ng-template>
</ap-modal>
}
 
@if (showConfirmUnMatchModal) {
<ap-modal #dstUnmatchConfirmDialog
         
          [appModalId]="'confirm-unmatch'"
          [ariaLabel]="'Unmatch statement confirmation'"
          [closable]="true"
          [style]="{'width': '31.25rem'}"
          (onClose)="closeDSTUnmatchConfirmDialog('confirm-unmatch')">
  <ng-template ngTemplate="header">
    <div class="flex-fill d-flex align-items-center">
      <ap-badge value="Warning" type="warning"></ap-badge>
      <span class="a-color-dark a-font-12">Statement Tracker Action</span>
    </div>
  </ng-template>
  <div class="st-modal-body">
    <div class="a-h3">Unmatch Statement</div>
    <div class="a-p4 ap-mt-spacing-3 text-description">Are you sure you want to unmatch this statement with requirement?</div>
  </div>
  <ng-template ngTemplate="footer">
    <ap-button [compact]="true" [btnType]="'secondary'" class="ap-mr-spacing-3" [label]="'NO'" class="ap-mr-spacing-3" (onClick)="closeDSTUnmatchConfirmDialog('confirm-unmatch')"></ap-button>
    <ap-button [compact]="true" [btnType]="'primary'" [label]="'YES'" (onClick)="closeDSTUnmatchConfirmDialogOk('confirm-unmatch')"></ap-button>
  </ng-template>
</ap-modal>
}
 
@if (showPDFViewerModal) {
<ap-modal #pdfViewerModal
         
          [appModalId]="'pdf-viewer'"
          [ariaLabel]="'Statement PDF viewer'"
          [closable]="true"
          [style]="{'width': '75rem'}"
          [contentStyle]="{'height': '80vh'}"
          (onClose)="closePDFViewerModalOk('pdf-viewer')">
  <div class="st-modal-body">
    @if (stmtDetailsLoaded) {
<gtw-form-review-pdf [rowData]="dstProformaData"
                         [divHeight]="'80vh'"></gtw-form-review-pdf>
}
  </div>
  <ng-template ngTemplate="footer">
    <ap-button [compact]="true" [btnType]="'primary'" [label]="'CLOSE'" (onClick)="closePDFViewerModalOk('pdf-viewer')"></ap-button>
  </ng-template>
</ap-modal>
}
 
@if (showProjectTaggingModal) {
<dst-project-tagging [rowObject]="activeRow" (afterModalClosed)="afterProjectTaggingModalClosed()"></dst-project-tagging>
}
@if (showCopyRepModal) {
<dst-copy-replicate [rowObject]="activeRow" [mode]="copyMode" (afterModalClosed)="afterCopyRepModalClosed()"></dst-copy-replicate>
}
@if (showMatchTrackerModal) {
<dst-match-tracker [rowObject]="activeRow"
                   (afterModalClosed)="afterMatchTrackerModalClosed()" (onSaveCompleted)="refresh(true)">
</dst-match-tracker>
}
@if (showOptionsModal) {
<dst-create-options [options]="formOptions" [rowObject]="activeRow" (afterModalClosed)="afterOptionsModalClosed($event)">
</dst-create-options>
}